export default "__VITE_ASSET__069bc9de__"